const getFaqmateEditorLocalStorage = (key = false) => {
    if (!window.localStorage) {
        return null;
    }

    if (!key) {
        return localStorage;
    }

    const faqmateSettingState = localStorage.getItem(key);

    if (faqmateSettingState) {
        return JSON.parse(faqmateSettingState);
    }

    return null;
};

export default getFaqmateEditorLocalStorage;
